<template>
  <div class="project-filter-wrap" v-if="isShow">
    <div class="project-filter">
      <h3 class="pa-5">新增Project Filter</h3>
      <label class="pa-5 d-flex h-64px align-center filter-title">
        <h4 class="w-80px mr-80px">Filter Title</h4>
        <div class="form-input-group flex-grow-1">
          <input type="text" v-model="title"/>
        </div>
      </label>
      <div class="pa-5 text-right filter-actions">
        <button class="btn mr-11px w-100px" @click="cancelHandler">取消</button>
        <button class="btn btn-primary w-100px" @click="saveHandler">
          儲存
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    title: '',
  }),
  methods: {
    ...mapActions({
      saveTabs: 'csr/saveTabs',
    }),
    cancelHandler() {
      this.$emit('close-creater');
    },
    async saveHandler() {
      await this.saveTabs({
        title: this.title,
      }).then(() => {
      });
      this.$emit('close-creater');
    },
  },
};
</script>

<style lang="scss">
.project-filter-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: rgba(70, 67, 67, 0.5);
  z-index: 100;
}

.project-filter {
  width: 720px;
  margin: 0 auto;
  margin-top: 168px;
  background-color: #fff;
  border-radius: 4px;

  h3 {
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }

  .filter-title {
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }

  .filter-actions {
    box-shadow: inset 0 1px 0 0 #d7dee7;
  }
}
</style>
